const getLocalState = state => state.pages.track || {}

export const getTitle = state => getLocalState(state).title
export const isHiRes = state => getLocalState(state).hires
export const getAlbum = state => getLocalState(state).album || {}
export const getDuree = state => getLocalState(state).duration
export const getArtist = state => getLocalState(state).artist || {}
export const getOrderUrl = state => getLocalState(state).orderUrl
export const getPerformer = state => getLocalState(state).performer


// WEBPACK FOOTER //
// ./src/pages/track/trackSelectors.js